import React from 'react'
import { Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Wordmark } from '@/design-system/atoms/Wordmark'

interface NavigationLogoProps {
    user: { id: string } | null
    onLogoClick: () => void
}

export const NavigationLogo: React.FC<NavigationLogoProps> = ({ user, onLogoClick }) => {
    const { t } = useTranslation()

    return (
        <Button
            onClick={onLogoClick}
            aria-label={user ? t('navigation:dashboard') : t('common:welcome')}
            color="inherit"
            sx={{
                flexGrow: 0,
                fontWeight: 700,
                mr: 4,
                textTransform: 'none',
                minWidth: 'auto',
                padding: 0,
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            }}
        >
            {/* Single source of truth for the styled wordmark: medium-weight base in
                the theme text color, with the italic coral ".io" suffix. */}
            <Typography variant="h6" component="span">
                <Wordmark baseColor="text.primary" baseFontWeight={500} />
            </Typography>
        </Button>
    )
}
